module.exports = __webpack_public_path__ + "img/emoji_89.45a5244f.png";